import widgetTypes from 'Constants/widget-types';
import { widgetSettings } from '@ast/default-settings';

export default widgetSettings[widgetTypes.shareRangeAnalysisResults];
